module.exports = __webpack_public_path__ + "static/media/hr.b55b7f0a.svg";